import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type GetPendingPunchesQueryVariables = Types.Exact<{
  startDate?: Types.InputMaybe<Types.Scalars['Date']>;
  endDate?: Types.InputMaybe<Types.Scalars['Date']>;
}>;


export type GetPendingPunchesQuery = { __typename?: 'Query', pendingPunches: Array<{ __typename?: 'PendingPunch', documentId: string, oldIn?: any | null, oldOut?: any | null, in?: any | null, out?: any | null, approved?: boolean | null, createdAt?: any | null, penalty?: number | null, approvedBy?: { __typename?: 'UsersPermissionsUser', documentId: string, username: string, firstName: string, lastName: string } | null, day?: { __typename?: 'Day', documentId: string, date?: any | null, user?: { __typename?: 'UsersPermissionsUser', documentId: string, username: string, firstName: string, lastName: string, email: string, color?: string | null, rewardCoins?: number | null } | null } | null, punch?: { __typename?: 'Punch', documentId: string, in?: any | null, out?: any | null, location: string } | null } | null> };


export const GetPendingPunchesDocument = `
    query getPendingPunches($startDate: Date, $endDate: Date) {
  pendingPunches(
    filters: {day: {date: {gte: $startDate, lte: $endDate}}}
    pagination: {limit: -1}
    sort: ["createdAt:desc"]
  ) {
    documentId
    oldIn
    oldOut
    in
    out
    approved
    createdAt
    penalty
    approvedBy {
      documentId
      username
      firstName
      lastName
    }
    day {
      documentId
      date
      user {
        documentId
        username
        firstName
        lastName
        email
        color
        rewardCoins
      }
    }
    punch {
      documentId
      in
      out
      location
    }
  }
}
    `;
export const useGetPendingPunchesQuery = <
      TData = GetPendingPunchesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPendingPunchesQueryVariables,
      options?: UseQueryOptions<GetPendingPunchesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPendingPunchesQuery, TError, TData>(
      variables === undefined ? ['getPendingPunches'] : ['getPendingPunches', variables],
      fetcher<GetPendingPunchesQuery, GetPendingPunchesQueryVariables>(client, GetPendingPunchesDocument, variables, headers),
      options
    );

useGetPendingPunchesQuery.getKey = (variables?: GetPendingPunchesQueryVariables) => variables === undefined ? ['getPendingPunches'] : ['getPendingPunches', variables];
;
